import React from 'react';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import type { FieldOperations } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import { useAssetTypes } from '@atlassian/jira-global-asset-types/src/components/index.tsx';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import { AssetTypeFieldConfiguration as AssetTypeFieldConfigurationView } from './view.tsx';

const AssetTypeFieldConfigurationWithHook = (props: FieldConfigurationComponentProps) => {
	const [{ assetTypes, error }] = useAssetTypes();

	return (
		<AssetTypeFieldConfigurationView {...props} assetTypes={assetTypes} assetFetchError={error} />
	);
};

export const AssetTypeFieldConfiguration = ComponentWithAnalytics('assetsFieldConfiguration', {
	onChange: 'updated',
})(AssetTypeFieldConfigurationWithHook);

export const isExpandable = (operations: FieldOperations) =>
	operations.canModifyPropertyConfiguration;
